// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    _productObj: {}
  }
};

timber.init = function () {
  // FastClick.attach(document.body);
  timber.cacheSelectors();
};

timber.productPage = function (options) {
  // console.log(options);
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      translations = options.translations,
      product = options.selector.product;
      // console.log(options)
      // console.log(variant.inventory_quantity)
  var item_id = "#" + selector.domIdPrefix;
  var $productImage = $(item_id).closest('form').find('.product-single__photos').find('img'),
 
      $addToCart = $(item_id).closest('form').find('.AddToCart:visible').not('.noClick'),
      $productPrice = $(item_id).closest('form').find('.product-single__price'),
      $productComparePrice = $(item_id).closest('form').find('.product-compare__price'),
      
      $addToCartText = $addToCart.find('.AddToCartText');
  // console.log(variant,product);
  // Update variant image, if one is set
  var newImg = variant && variant.featured_image ? variant.featured_image.src : product.featured_image,
      newImgId = variant && variant.featured_image ? variant.featured_image.id : '',
      el = $productImage[0];
    timber.switchImage(newImg,{ id: newImgId }, el);

  if (variant) {
    // Select a valid variant if available
    if (variant.available) {
      if($addToCartText.data("type") && $addToCartText.data("type") == 'pre_order'){
        $addToCartText.html(translations.pre_order_now);
        $addToCartText.attr('text', translations.pre_order_now);
      }else{
        $addToCartText.html(translations.add_to_cart);
        $addToCartText.attr('text', translations.add_to_cart);
      }
      $addToCart.removeClass('disabled').prop('disabled', false);
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      // console.log(translations.sold_out)
      $addToCartText.html(translations.sold_out);
      $addToCartText.attr('text', translations.sold_out);
      $addToCart.addClass('disabled').prop('disabled', true);
    }

    // Regardless of stock, update the product price
    var variantPrice = Shopify.formatMoney(variant.price, moneyFormat);
    $productPrice.html(variantPrice);
    $productPrice.attr('content', (variant.price / 100).toFixed(2));
    if ($productComparePrice) {
      $productComparePrice.hide();
      if (variant.compare_at_price > variant.price) {
        var variantComparePrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
        $productComparePrice.show().html(variantComparePrice);
        $productComparePrice.attr('content', (variant.compare_at_price / 100).toFixed(2));
      }
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $addToCartText.attr('text', translations.unavailable);
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  // console.log(el)
  var $el = $(el);
  if (!$el.length) {
    return;
  }
  if (!src && imgObject && imgObject.src) {
    src = imgObject.src;
  }
  if (!src) {
    if (imgObject && imgObject.id) {
      $el.attr('data-image-id', imgObject.id);
    }
    return;
  }
  $el.attr('src', src);
  $el.attr('data-src', src);
  if (imgObject && imgObject.id) {
    $el.attr('data-image-id', imgObject.id);
  }
};

timber.selectVariant = function(index, productObj){
  new Shopify.OptionSelectors(`productSelect_${index}`, {
    product: productObj,
    onVariantSelected: typeof gridFormSelectCallback === 'function' ? gridFormSelectCallback : selectCallback,
    enableHistoryState: false
  });
}

timber.changeOption = function (product_handle,selectValue,selectIndex){
  const productOptions = timber.cache._productObj.options;
  // console.log(product)
  let singleOption_index = 0;
  if (product_handle == 'magez-case-for-iphone-12' || product_handle == 'magez-case-2-for-ipad-pro-2022' || product_handle == 'magez-case-pro-for-ipad-pro-2022' ) {
    singleOption_index = 2;
  }
  let length = 1;
  for (let i = 0; i < productOptions.length; i++) {
    const singleOptionSelector = `#productSelect_${selectIndex}-option-${i}`;
    const singleOptionLength = document.querySelector(singleOptionSelector).children.length;
    length *= singleOptionLength;
  }

  const options = document.querySelector(`#productSelect_${selectIndex}`).children;
  const optionLength = options.length - 1;
  if (length == optionLength) {
    return;
  }

  const swatchSelectClass = productOptions[1].name.toLowerCase();
  const productSelectId = `#productSelect_${selectIndex}-option-${singleOption_index}`;

  const singleOptions =  document.querySelector(productSelectId).children;
  var optionArr = [];
  for (let j = 0; j < singleOptions.length; j++) {
    const singleOptionValue = singleOptions[j].innerText;
    var optionData = {};
    //console.log(singleOptionValue)
    var singleArr = [];
    for (let i = 0; i < optionLength; i++) {
      /* 剥价格：原来切分用的分隔串**带美元符号**，那是美国站遗留。
         本店计价是 SR，该串永不匹配 => 价格根本没被剥掉 => optionValueArr 的最后一段
         带着价格后缀，与色球的 data-value 永远对不上 => 这条级联把所有花色都判为不可用。
         改用 lastIndexOf，同时也修掉值内含「空格短横空格」的花色被截断的问题
         （PTK Weaving - Charoite Purple (PitaTap™)）。 */
      const optionText = options[i].innerText.trim();
      const optionPriceCut = optionText.lastIndexOf(' - ');
      const optionValue = optionPriceCut > -1 ? optionText.slice(0, optionPriceCut) : optionText;
      const optionValueArr = optionValue.split(" / ");
      if (optionValueArr[singleOption_index] == singleOptionValue) {
        singleArr.push(optionValueArr[1]);
      }
    }
    var singleUniqueArr = singleArr.filter(function(item,index){
      return singleArr.indexOf(item) == index;
    })

    // console.log(singleArr)
    if (singleUniqueArr.length > 0) {
      optionData.option = swatchSelectClass;
      optionData.name = singleOptionValue;
      optionData.arr = singleUniqueArr;

      optionArr.push(optionData); 
    }
  }
  // console.log(optionArr)
  for (let index = 0; index < optionArr.length; index++) {
    const name = optionArr[index].name;
    // console.log(name,selectValue);
    if (name == selectValue) {
      const valueList = optionArr[index].arr;
      const swatchClass = optionArr[index].option;
      $(`.grid-form-modal .swatch-element.${swatchClass}`).each(function(){
        let $this_swatch = $(this);
        const swatchValue = $this_swatch.data('value');

        if (valueList.includes(swatchValue)) {
          $this_swatch.find("input[type='radio']").prop("disabled", false);
          $this_swatch.removeClass("disable");
        }else{
          $this_swatch.find("input[type='radio']").prop("disabled", true);
          $this_swatch.addClass("disable");
        }
      });

      const radioValue = $(`#productSelect_${selectIndex}-option-1`).val();
      const checkReturn = valueList.length === 1 ? valueList.includes(radioValue) : (valueList.includes(radioValue) || radioValue == "");

      if (checkReturn) {
        return;
      }

      $(`.grid-form-modal .swatch-element.${swatchClass}`).not('.disable').eq(0).find("input[type='radio']").click();
    }
  }
}

timber.renderFormModal = function (product_handle,form_index,selected_variant) {
  $.getJSON(`/products/${product_handle}.js`, function (product) {
    // console.log(product)
    timber.cache._productObj = product;
    if(!product.available){
      return false;
    }
    const product_variants = product.variants;
    const form_variant = product_variants.filter(item => item.available)[0];
    const form_id = `form_${form_variant.id}`;
    const variant_image = form_variant.featured_image;
    const variant_image_180 = variant_image ? variant_image.src.split('.webp')[0] + '_180x180.webp' + variant_image.src.split('.webp')[1] : product.featured_image;
    const variant_image_id = variant_image ? variant_image.id : form_variant.id;

    let form_title;
    const formTitleClass = 'text-size-14 sm:text-size-16 lg:text-size-18 2xl:text-size-20 font-bold leading-tight';
    const formDescClass = 'text-size-12 sm:text-size-13 lg:text-size-14 2xl:text-size-16';
    let title_parts = product.title.split(' for ');
    if (product_handle.includes('for') && product_handle.includes('case')) {
      if (product_handle.includes('fusion-weaving')) {
        form_title = `<h4 class="${formTitleClass}">
          <span class="block w-max">${title_parts[0]}</span>
          <span class="block ${formDescClass}">For ${title_parts[1]}</span>
        </h4>`
      }else{
        let title_html;
        if(product_handle == 'flipbook-case-for-ipad-pro-with-keyboard'){
          title_parts = product.title.split(' with ');
          title_html = `<span class="block w-max">
            ${title_parts[0]} with <br>
            ${title_parts[1]}
          </span>`;
        }else if(product_handle == 'magez-case-4-for-samsung-galaxy-s24'){
          title_html = `<span class="block">MagEZ Case 4</span>
            <span class="block ${formDescClass}">
              Samsung Galaxy S24 <span class="hidden sm:inline">/S24 Plus/S24 Ultra Case</span><span class="inline sm:hidden">Series</span> 
            </span>`;
        }else{
          if(product_handle.includes('member-only')){
            title_html = `<span class="text-size-16 sm:text-size-18 2xl:text-size-24 font-bold">
                ${title_parts[0].split(' - ')[0]} - 
              </span>
              <span class="text-size-20 sm:text-size-24 2xl:text-size-30">
                ${title_parts[0].split(' - ')[1]}
              </span><span class="block ${formDescClass}">
                For ${ title_parts[1].replace(' & ', '/')}
              </span>`;
          }else{
            title_html = `<span class="block">
              ${title_parts[0].replace('PITAKA ','')}
            </span><span class="block ${formDescClass}">
              For ${ title_parts[1].replace(' & ', '/')}
            </span>`;
          }
        }
        form_title = `<h4 class="${formTitleClass} flex-shrink-0">${title_html}</h4>`;
      }
    }else{
      let title_html;
      if(product_handle.includes('-for-') || product_handle.includes('magez-folio') || product_handle == 'carbon-fiber-watch-band'){
        if(product_handle.includes('pitatag')){
          title_html = `<span class="block">${product.title}</span>
          <span class="block ${formDescClass}">For AirTag</span>`;
        }else if(product_handle.includes('easter-red-rabbit')){
          title_html = `<span class="block">${product.title}</span>
          <span class="block ${formDescClass}">For iPhone 14 Pro/Pro Max</span>`;
        }else{
          title_html = `<span class="block w-max">${title_parts[0]}</span><span class="block ">For ${title_parts[1]}</span>`;
        }
      }else if(product_handle == "magez-charging-stand"){
        title_html = `MagEZ Charging Stand
        <span class="block ${formDescClass}">
          For iPad mini 6 & iPad 2022 Series
        </span>`;
      }else if(product_handle == 'pitaflow-charger'){
        title_html = `PitaFlow Charger
        <span class="block ${formDescClass}">
          For iPad MagEZ Case Pro
        </span>`;
      }else if(product_handle == 'donate-your-rewards-points-to-a-non-profit'){
        title_html = `${product.title}<span class="block ${formDescClass}">
          15 POINTS = 1 TREE
        </span>`;
      }else{
        title_html = product.title;
      }
      form_title = `<h4 class="${formTitleClass} flex-shrink-0">${title_html}</h4>`;
    }
    const variant_price = Shopify.formatMoney(form_variant.price, "");
    let form_prices = `<span class="product-single__price" itemprop="price">
        ${variant_price}
      </span>`;
    if(form_variant.compare_at_price > form_variant.price){
      const variant_compare_price = Shopify.formatMoney(form_variant.compare_at_price, "");
      form_prices += `<span class="product-compare__price line-through font-normal ml-1">
        ${variant_compare_price}
      </span>`;
    }
    let quantifyMax = form_variant.inventory_policy == 'deny' ? form_variant.inventory_quantity : 999;
    let form_options = '';
    for (let i = 0; i < product_variants.length; i++) {
      const variant_item = product_variants[i];
      const variant_quantifyMax = variant_item.inventory_policy == 'deny' ? variant_item.inventory_quantity : 999;
      const variant_item_price = Shopify.formatMoney(variant_item.price, "");
      const form_option = `<option value="${variant_item.id}" data-quantity="${variant_quantifyMax}">
        ${variant_item.title} - ${variant_item_price}
      </option>`;
      form_options += form_option;
    }
    form_options += `<option value="${form_variant.id}" data-quantity="${quantifyMax}">
        ${form_variant.title} - ${variant_price}
      </option>`;
    let form_swatches = '',form_button;
    const handlezie_value = value => value.replaceAll(/[\/\`\~\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\|\[\]\:\;\'\<\>\?\,\.]+/g,' ').replace(/\s+/g,' ').trim().replaceAll(' ','-').toLowerCase();
    
    let product_name = product_handle;
    let remove_strs;;
    if (product_handle.includes('-case-')) {
      if (product_handle.includes('chinese-new-year')){
        product_name = 'chinese-dragon-case5';
      }else if (product_handle.includes('sunset-moonrise-case')){
        product_name = 'sunset-moonrise-case';
      }else if (product_handle.includes('three-body')){
        product_name = 'three-body';
      }else{
        remove_strs = ['pitaka-','case-','for-','samsung-galaxy-','google-','huawei-','-series','-iphone-14-and-galaxy-s23','phone-'];
        // product_name = remove_strs.forEach(item => {product_handle.replace(item,'')});
        product_name = product_name.replace('pro-2020-and-2018', '2020');
        for (let index = 0; index < remove_strs.length; index++) {
          const str = remove_strs[index];
          product_name = product_name.replace(str,'');
        }
      }
    }else if (product_handle == 'carbon-fiber-watch-band-rhapsody-version-for-apple-watch') {
      product_name = 'iwatch-band';
    }else if (product_handle.includes('dreamland-chromacarbon-band')) {
      product_name = 'dreamland-chromacarbon-iwatch-band';
    }else if (product_handle.includes('poetry-of-things-chromacarbon-band')) {
      product_name = 'poetry-chromacarbon-band';
    }else if (product_handle == 'screen-protector-for-samsung-galaxy-s24') {
      product_name = 'screen-protector-galaxy-s24';
    }else {
      remove_strs = ['pitaka-','-for-s24','-for-airtag','magez-','air-','for-','-iphone-14-and-galaxy-s23'];
      remove_strs.forEach(item => {
        if(product_name.includes(item)){
          product_name = product_name.replace(item,'');
        }
      });
    }
    if(product.available && product_variants.length > 1){
      for (let i = 0; i < product.options.length; i++) {
        const option = product.options[i].name;
        const downcased_option = handlezie_value(option);
        let is_color = false, is_device = false, is_casetype = false, color_index = 0;

        if(downcased_option.includes('color') || downcased_option.includes('colour') || downcased_option == 'carbon-fiber-watch-band'){
          is_color = true;
          color_index = i;
        }
        if(downcased_option == 'case-type'){
          is_casetype = true;
        }
        if(downcased_option == 'device'){
          is_device = true;
        }
        const swatch_title = is_color || is_device ? `${option} <span class="option_context_${downcased_option} ml-1 font-normal"></span>` : option;
        let swatch_variants = '', roundedClass, variant_values = [];
        for (let j = 0; j < product_variants.length; j++) {
          let variant_value = product_variants[j].options[i].trim();
          const raw_option_value = variant_value;
          if(!variant_values.includes(variant_value)){
            variant_values.push(variant_value);
            if(is_color){
              roundedClass = 'color mr-1.5 mb-1 sm:mr-2 sm:mb-1.5 xl:mr-3';
            }else{
              roundedClass = `${downcased_option} mr-1.5 mb-1.5 sm:mr-2 xl:mb-2`;
            }
            if(product_handle.includes('samsung-galaxy-')){
              variant_value = variant_value.replace('+','p');
            }
            // const patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
            const handle_value = handlezie_value(variant_value);
            // const bgt_1500d = ['Case Pro/ Black/Grey','Air Case-Black(no magsafe)','Modern','Retro'];
            // const bgt_600d = ['Air Case-Black(no magsafe)'];
            // if (bgt_1500d.includes(variant_value)) {
            //   handle_value = 'black-grey-twill';
            // }else if(bgt_600d.includes(variant_value)){
            //   handle_value = '600d-black-grey-twill';
            // };
            let swatch_label;
            if(is_color){
              let color_src;
              let color_prefix = product_handle.includes('pixel-game') ? 'weaving-pixel-game' : handle_value.replace('1500d-','');
              let is_webp = variant_value.includes('Forest') || variant_value.includes('Canyon') || variant_value.includes('Bonfire') || variant_value.includes('Ocean');
              // 🔴 色球图路径统一走 layout/theme.liquid 的 pitakaSwatchColorUrl，
              // 与 snippets/swatch.liquid（PDP 服务端渲染）是同一套规则；改分支必须三处同步。
              try {
                if (typeof window.pitakaSwatchColorUrl === 'function') {
                  color_src = window.pitakaSwatchColorUrl(product_handle, raw_option_value);
                }
              } catch (err) {
                color_src = '';
              }
              if (!color_src) {
                if (product_handle.includes('aries-collab') && product_handle.includes('cases')) {
                  color_prefix = `case-${color_prefix}`;
                } else if (product_handle.includes('aries-collab') && product_handle.includes('charm')){
                  color_prefix = `keychain-${color_prefix}`;
                }
                const ext = (is_webp || product_handle.includes('three-body') || product_handle.includes('pixel-game') || product_handle.includes('aries-collab')) ? '.webp' : '.svg';
                color_src = `//pitaka-ar.com/cdn/shop/t/11/assets/${color_prefix}${ext}`;
              }
              // let color_prefix = product_handle.includes('red-white-blue') ? `weaving-${handle_value}` : handle_value;
              // let color_src;
              // if(product_handle.includes('us-warehouse-sale-')){
              //   color_src = `https://www.ipitaka.com/cdn/shop/t/79/assets/${color_prefix}.svg`;
              // }else{
              //   color_src = `https://www.ipitaka.com/cdn/shop/t/79/assets/card-${product_name}-${color_prefix}.webp?v=2024`;
              // }
              let soldout_src = `//pitaka-ar.com/cdn/shop/t/11/assets/soldout.webp?v=98353485980400487931747824399`;
              swatch_label = `<label for="swatch_${form_index}-${i}-${handle_value}" data-src="${color_src}"
                class="bg-no-repeat bg-center bg-cover bg-white w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden border border-transparent relative"       
                style="background-image: url(${color_src});">
                <img class="crossed-out" src="${soldout_src}"/>
              </label>`;

              
            }else{

              if (variant_value.includes('--')) {
                swatch_label = `<label class="border border-black border-opacity-60 bg-white text-center px-4 py-2 leading-tight relative"
                  for="swatch_${form_index}-${i}-${handle_value}">
                  <span class="block text-size-12 sm:text-size-14 font-bold">${variant_value.split('--')[0]}</span>
                  <span class="block text-size-12 opacity-80 mt-0.5">${variant_value.split('--')[1]}</span>
                </label>`;
              } else {
                swatch_label = `<label class="border border-black border-opacity-60 bg-white px-4 py-2 leading-tight relative"
                  for="swatch_${form_index}-${i}-${handle_value}">
                    <span class="text-size-12 sm:text-size-14">${variant_value}</span>
                </label>`;
              }
            }
            const swatch_variant = `<div data-value="${variant_value}"
              class="text-size-12 swatch-element w-full max-w-max ${roundedClass} ${handle_value} available">
              <input id="swatch_${form_index}-${i}-${handle_value}" 
                type="radio" name="option-${i}" value="${variant_value}"
              />${swatch_label}</div>`;
            swatch_variants += swatch_variant;
          }
        }

        let swatchHidden = '';
        if (product_handle.includes('phone-cases') && is_device) {
          swatchHidden = ' hidden';
        }
        form_swatches += `<div class="swatch swatch-${downcased_option} clearfix mb-3 sm:mb-5 xl:mb-6${swatchHidden}" 
          data-option-index="${i}">
          <h3 class="heading text-size-12 font-bold mb-1 sm:mb-1.5">
            ${swatch_title} 
          </h3>
          <div class="flex flex-wrap -mb-2">${swatch_variants}</div></div>`;
      }
    }
    if(product.available){
      form_button = `<button type="submit" name="add" class="AddToCart rounded">
        <span class="AddToCartText" text="Add to cart">Add to cart</span>
      </button>`;
    }else{
      form_button = `<button type="submit" name="add" class="AddToCart rounded disabled">
        <span class="AddToCartText" text="Unavailable">Unavailable</span>
      </button>`;
    }

    let gallery_items = '';
    if (product.variants.length > 1) {
      for (const variant of product.variants) {
        gallery_items += `<li data-image-id="${ variant.featured_image.id }" title="${variant.title}" 
          class="gallery__item" data-mfp-src="${variant.featured_image.src}"></li>`;
      }
    } else {
      gallery_items == `<li data-image-id="${form_variant.id}" title="${product.title}" 
        class="gallery__item" data-mfp-src="${product.featured_image}"></li>`;
    }

    const gridFormModal = `<div class="grid-form-modal  fixed inset-0 flex items-end md:items-center justify-center bg-black bg-opacity-50 z-10 active" data-product="${product_handle}">
      <div class="w-full sm:w-4/5 md:w-2/5 xl:w-1/3 h-9/10 sm:h-5/6">
        <form action="/cart/add" class="w-full h-full flex flex-col bg-white rounded relative" enctype="multipart/form-data" method="post">
          <div class="form_btn-close absolute top-4 right-4 sm:-right-8 sm:-top-6 w-6 h-6 sm:w-8 sm:h-8 bg-black bg-opacity-20 sm:bg-opacity-100 sm:bg-white rounded-full flex items-center justify-center cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
              width="18.85595703125" height="18.856170654296875" viewBox="0 0 18.85595703125 18.856170654296875"
              class="block w-4/5 h-auto">
              <g
                transform="matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,2.761391088439268,-6.666587427185732)">
                <g>
                  <g>
                    <line x1="9.427978515625" y1="6.7727274894714355" x2="22.761310577392578" y2="6.7727274894714355"
                      fill-opacity="0" stroke-opacity="1" stroke="#000000" fill="none" stroke-width="1"></line>
                  </g>
                  <g transform="matrix(0,-1,1,0,3.3673739433288574,30.034038066864014)">
                    <line x1="16.700706005096436" y1="12.833332061767578" x2="30.034038066864014" y2="12.833332061767578"
                      fill-opacity="0" stroke-opacity="1" stroke="#000000" fill="none" stroke-width="1"></line>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="h-1/5 flex items-stretch p-4">
            <div class="product-single__photos flex-shrink-0 bg-black bg-opacity-5 relative">
              <img data-src="${variant_image_180}" data-image-id="${variant_image_id}"
                class="variant__image block w-full h-full object-contain object-center lazyload"
                alt="${product.title}">
            </div>
            <ul class="gallery hidden">
              ${gallery_items}
            </ul>
            <div class="w-full pl-2.5">
              <div class="product_content-title" itemprop="name">
                ${form_title}
              </div>
              <div class="product_content-prices flex items-center justify-between">
                <div class="form-single__prices ${formTitleClass}">
                  ${form_prices}
                </div>
                <div class="product-single__quantity">
                  <div class="number-box flex items-center text-size-12">
                    <input type="button" class="on-number" data-v="-1" value="-" disabled>
                    <input name="quantity" type="text" value="1" data-min="1" data-max="${quantifyMax}">
                    <input type="button" class="on-number" data-v="1" value="+">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <input type="hidden" name="cart_autoClose" value="1">
          <div class="main-form-container h-4/5 flex flex-col justify-between">
            <div class="variant-select-container h-full bg-black bg-opacity-5 px-4 py-3 overflow-y-auto">
              <select name="id" id="productSelect_${ form_index }" class="product-single__variants hidden">
                ${form_options}
              </select>
              ${form_swatches}
            </div>
            <div class="flex-shrink-0 product-cart w-full bg-white p-4">
              <div class="product-form__buttons w-full grid grid-cols-1 gap-4 sm:gap-6">
                <div class="addtocartBtn">${form_button}</div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>`;

    $("#PageContainer").after(gridFormModal);

    timber.selectVariant(form_index, product);
    if(selected_variant != ''){
      const value_arr = selected_variant.split(' / ');
      for (let i = 0; i < value_arr.length; i++) {
        const val = value_arr[i];
        $('.grid-form-modal').find( `.swatch :radio[value='${val}']`).click();
      }
    }

    $('.grid-form-modal').find('.gallery__item').magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
      closeOnBgClick: true,
      closeBtnInside: false,
      closeOnContentClick: true,
      tClose: 'Translation missing: ar.products.zoom.close',
      removalDelay: 500,
      callbacks: {
        open: function(){
          $('html').css('overflow-y','hidden');
        },
        close: function(){
          $('html').css('overflow-y','');
        }
      },
      titleSrc: 'title',
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
        tPrev: 'Translation missing: ar.products.zoom.prev',
        tNext: 'Translation missing: ar.products.zoom.next'
      }
    });
  });
}
// Initialize Timber's JS on docready
$(timber.init)